import { baseSplitApi as api } from "./baseApi";

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    requestResetPassword: build.mutation<
      RequestResetPasswordApiResponse,
      RequestResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/auth/request-reset-password`,
        method: "POST",
        body: queryArg.resetPasswordRequest,
      }),
    }),
    resetPassword: build.mutation<
      ResetPasswordApiResponse,
      ResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/v1/auth/reset-password`,
        method: "POST",
        body: queryArg.resetPasswordUpdateRequest,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as bigsystherApi };
export type RequestResetPasswordApiResponse =
  /** status 200 Token for reset */ SuccessResponse200;
export type RequestResetPasswordApiArg = {
  /** Payload with user email */
  resetPasswordRequest: ResetPasswordRequest;
};
export type ResetPasswordApiResponse =
  /** status 200 Password was changed */ SuccessResponse200;
export type ResetPasswordApiArg = {
  /** Payload with update request */
  resetPasswordUpdateRequest: ResetPasswordUpdateRequest;
};
export type SuccessResponse200 = {
  status?: string;
};
export type ValidationError = {
  field?: string;
  message?: string;
};
export type ErrorResponse400 = {
  code?: number;
  data?: ValidationError[];
  message?: string;
};
export type ResetPasswordRequest = {
  email: string;
};
export type ResetPasswordUpdateRequest = {
  newPassword?: string;
  token?: string;
};
export const { useRequestResetPasswordMutation, useResetPasswordMutation } =
  injectedRtkApi;
